{
	"all": "All",
	"emptyMessage": "No products found",
	"product": "Product",
	"sku": "SKU",
	"price": "Price",
	"mountable": "Mountable"
}
